import type { IResponse, IApiResponse } from "../@types/ApiResponse";
import { emptySplitApi } from "./emptySliceApi";
import endpoints from "./endpoints";

export const alertApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    GetAlerts: builder.query<IApiResponse<Alert.AlertDto>, any>({
      query: (filter) => {
        return {
          url: endpoints.alerts.base,
          method: "GET",
          params: filter,
        };
      },
      providesTags: ["Alert"],
    }),
    GetAlertById: builder.query<IResponse<Alert.AlertDto>, number>({
      query: (id) => {
        return {
          url: endpoints.alerts.details(id),
          method: "GET",
        };
      },
      providesTags: ["Alert"],
    }),
    CreateAlert: builder.mutation<
      IResponse<Alert.AlertDto>,
      Alert.AlertCreateDto
    >({
      query: (alertData) => {
        return {
          url: endpoints.alerts.base,
          method: "POST",
          body: alertData,
        };
      },
      invalidatesTags: ["Alert"],
    }),
    UpdateAlert: builder.mutation<
      IResponse<Alert.AlertDto>,
      Alert.AlertUpdateDto
    >({
      query: (alertData) => {
        const { id, ...updateData } = alertData;
        return {
          url: endpoints.alerts.details(id),
          method: "PUT",
          body: updateData,
        };
      },
      invalidatesTags: ["Alert"],
    }),
    DeleteAlert: builder.mutation<IResponse<null>, number>({
      query: (id) => {
        return {
          url: endpoints.alerts.details(id),
          method: "DELETE",
        };
      },
      invalidatesTags: ["Alert"],
    }),
    SendAlert: builder.mutation<IResponse<null>, number>({
      query: (id) => {
        return {
          url: endpoints.alerts.send(id),
          method: "POST",
        };
      },
      invalidatesTags: ["Alert"],
    }),
  }),
});

export const {
  useGetAlertsQuery,
  useGetAlertByIdQuery,
  useCreateAlertMutation,
  useUpdateAlertMutation,
  useDeleteAlertMutation,
  useSendAlertMutation,
} = alertApi;
